import React, { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { Button, Form, Icon, Table, Modal } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import useQuery from '../../../utils/use-query'
import classes from './template.module.css'

import {
  CreateTemplate,
  GetConfigTemplate,
} from '../../../services/configuration-template'
// import { AssetViewContext } from '../../assets/asset-info-view/assetView'
import StatusDialog from '../../status-dialog'
import { RefreshCustomerAssetList } from '../../../redux/actions/asset'
import { primaryColor, secondaryColor } from '../../../constants'
import IntelMsg from '../../ItelMsg'
import ValidatorGenerator from '../../../services/configuration-template/validatores'

export default function ConfTemplate() {
  const history = useHistory()
  const query = useQuery()
  const [disableSubmit] = useState(false)
  const [showDialog, setShowDialog] = useState(false)
  const [positive] = useState(false)
  const [dataConfigurations, setDataConfigurations] = useState([])
  const [dialogContent, setDialogContent] = useState('')
  const [dialogHeader, setDialogHeader] = useState('')
  const assetName = query.get('assetName')
  const assetLabel = query.get('assetLabel')
  const dispatch = useDispatch()
  const { register, handleSubmit, errors, clearErrors } = useForm()

  const { t } = useTranslation()
  // assetCustomerData customer id

  const productName = localStorage.getItem('product')
  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))
  const customer = localStorage.getItem('customer')
  console.log('customerrrr', customer)
  // const sorting = (config1, config2) => {
  //   if (config1.sort < config2.sort) {
  //     return -1
  //   }
  //   if (config1.sort > config2.sort) {
  //     return 1
  //   }
  //   // a must be equal to b
  //   return 0
  // }

  useEffect(() => {
    const assetData = {}
    assetData.type = query.get('assetType')
    console.log('asset type', assetData.type)
    if (userEmail) {
      GetConfigTemplate(productName, userEmail, assetData.type)
        .then((configData) => {
          console.log('configDataaaa', configData)
          const thresholds = JSON.parse(
            configData.thresholdsConfigurationAttributes,
          )
          console.log('thresholds', thresholds)
          // configData.thresholds.sort(sorting)
          setDataConfigurations(thresholds)
        })
        .catch((e) => console.log(e))
    }
  }, [])

  async function onSubmit(data) {
    console.log('msdata', data)
    clearErrors()
    const assetData = {}
    assetData.id = query.get('assetID')
    assetData.name = query.get('assetName')
    assetData.assetType = query.get('assetType')
    CreateTemplate(productName, assetData, customer, data, 'create').then(
      (creationResponse) => {
        console.log('response', creationResponse)
        if (creationResponse.success) {
          // setPositive(true)
          // setInterval(() => {
          //   setPositive(false)
          // }, 1000000)
          dispatch(RefreshCustomerAssetList(true))
          history.goBack()
        } else {
          setDialogHeader('Template creation Error')
          setDialogContent(
            <>
              <Icon name="exclamation triangle" size="huge" color="red" />
              <p style={{ fontSize: 'x-large' }}>{creationResponse.msg}</p>
            </>,
          )
          setShowDialog(true)
        }
      },
    )
  }

  const generateInputTableRow = (
    iconName,
    labelId,
    validatorType,
    inputPlaceholder,
    inputName,
    inputType,
    errMsg,
  ) => (
    <Table.Row>
      <Table.Cell verticalAlign="middle">
        <Icon name={iconName} /> <IntelMsg id={labelId} />
      </Table.Cell>
      <Table.Cell>
        {inputType === 'BOOLEAN'
          ? generateInputBoolean(inputName, labelId)
          : generateInputString(
              inputType,
              inputName,
              inputPlaceholder,
              validatorType,
              errMsg,
            )}
      </Table.Cell>
    </Table.Row>
  )

  const generateInputString = (
    inputType,
    inputName,
    inputPlaceholder,
    validatorType,
    errMsg,
  ) => {
    const validate = ValidatorGenerator(validatorType)

    return (
      <>
        <input
          type={inputType === 'NUMERIC' ? 'number' : 'text'}
          ref={register({ validate })}
          placeholder={t(inputPlaceholder)}
          style={{ width: '100%' }}
          name={inputName}
        />
        <div style={{ color: 'red' }}>
          {errors[inputName] ? <IntelMsg id={errMsg} /> : '**'}
        </div>
      </>
    )
  }

  const generateInputBoolean = (inputName, inputLabel) => (
    <Form.Field style={{ display: 'flex', alignItems: 'center' }}>
      <input
        type="checkbox"
        ref={register({ required: false })}
        defaultChecked
        name={inputName}
      />
      <strong>
        &nbsp;
        <IntelMsg id={inputLabel} />
      </strong>
    </Form.Field>
  )
  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)} id="templateForm" noValidate>
        <Table celled striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className={classes.header} width={5}>
                {assetLabel || assetName}
                <IntelMsg id=" Thresholds" />
              </Table.HeaderCell>
              <Table.HeaderCell className={classes.header}>
                <IntelMsg id="templateHeaderValue" />
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {dataConfigurations.map((row) =>
              generateInputTableRow(
                row['icon name'],
                row['label ID'],
                row['validator type'],
                row.placeholder,
                row['input name'],
                row['input type'],
                row['err msg'],
              ),
            )}
          </Table.Body>
        </Table>
        {positive ? (
          <Modal size="tiny" open={positive}>
            <Modal.Header>Assign Template</Modal.Header>
            <Modal.Content>
              <Icon name="thumbs up outline" size="huge" color="green" />
              <p>New Template Created And Assigned To The Asset</p>
            </Modal.Content>
          </Modal>
        ) : null}

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
            padding: '12px',
          }}
        >
          <Button
            onClick={() => {
              history.replace('/asset/management')
              history.goBack()
            }}
            size="tiny"
            style={{
              background: primaryColor,
              color: 'white',
            }}
            icon
            labelPosition="left"
          >
            <Icon name="arrow left" />
            <div>Back</div>
          </Button>

          <Button
            icon
            style={{
              background: secondaryColor,
              color: 'white',
            }}
            labelPosition="left"
            type="submit"
            form="templateForm"
            disabled={disableSubmit}
          >
            <Icon name="save" />
            <div>Save And Assign</div>
          </Button>
        </div>
      </Form>
      <StatusDialog
        showDialog={showDialog}
        setShowDialog={setShowDialog}
        dialogHeader={dialogHeader}
        dialogContent={dialogContent}
      />
    </>
  )
}
